<div class="assessment-modal">
  <div class="modal-header">
    <div>
      <h2>{{ isEdit ? "Edit Assessment" : "Add Assessment" }}</h2>
      <p>
        {{
          isEdit
            ? "Update assessment "
            : "Create a proctored assessment and pick an existing ruleset to apply"
        }}
      </p>
    </div>

    <button class="close-btn" (click)="closeDialog()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>

  <form [formGroup]="assessmentForm">
    <div class="section">
      <h5 class="section-title">ASSESSMENT DETAILS</h5>

      <div class="row">
        <div class="form-group">
          <label> Assessment Code <span>*</span></label>

          <input type="text" placeholder="e.g. ASMT-9001" 
          formControlName="proctoringEvaluationOnId" [readonly]="isEdit" [title]="isEdit ? 'Not editable' : ''" />
            <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('proctoringEvaluationOnId')?.touched && assessmentForm.get('proctoringEvaluationOnId')?.errors?.['required']">
                  Assessment Code is required.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('proctoringEvaluationOnId')?.touched && assessmentForm.get('proctoringEvaluationOnId')?.errors?.['minLength']">
                  Assessment Code must contain at least 3 characters.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('proctoringEvaluationOnId')?.touched && assessmentForm.get('proctoringEvaluationOnId')?.errors?.['maxLength']">
                  Assessment Code cannot exceed 100 characters.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('proctoringEvaluationOnId')?.touched && assessmentForm.get('proctoringEvaluationOnId')?.errors?.['trimSpaces']">
                  Leading and trailing spaces are not allowed.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('proctoringEvaluationOnId')?.touched && assessmentForm.get('proctoringEvaluationOnId')?.errors?.['whitespace']">
                  Assessment Code cannot be empty.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('proctoringEvaluationOnId')?.touched && assessmentForm.get('proctoringEvaluationOnId')?.errors?.['invalidCharacters']">
                  Invalid characters are not allowed.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('proctoringEvaluationOnId')?.touched && assessmentForm.get('proctoringEvaluationOnId')?.errors?.['firstCharacter']">
                  Assessment Code cannot start with a special character.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('proctoringEvaluationOnId')?.touched && assessmentForm.get('proctoringEvaluationOnId')?.errors?.['duplicate']">
                  Assessment Code already exists.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('proctoringEvaluationOnId')?.touched && assessmentForm.get('proctoringEvaluationOnId')?.errors?.['html']">
                  Invalid input detected.
                </small>
        </div>

        <div class="form-group">
          <label> Assessment Name<span>*</span> </label>

          <input type="text" placeholder="e.g. Data Engineer — Screening" 
          formControlName="evaluationTitle"/>
           <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('evaluationTitle')?.touched && assessmentForm.get('evaluationTitle')?.errors?.['required']">
                  Assessment Name is required.
                </small>

           <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('evaluationTitle')?.touched && assessmentForm.get('evaluationTitle')?.errors?.['minLength']">
                  Assessment name must contain at least 3 characters.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('evaluationTitle')?.touched && assessmentForm.get('evaluationTitle')?.errors?.['maxLength']">
                  Assessment name cannot exceed 100 characters.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('evaluationTitle')?.touched && assessmentForm.get('evaluationTitle')?.errors?.['trimSpaces']">
                  Leading and trailing spaces are not allowed.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('evaluationTitle')?.touched && assessmentForm.get('evaluationTitle')?.errors?.['whitespace']">
                  Assessment name cannot be empty.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('evaluationTitle')?.touched && assessmentForm.get('evaluationTitle')?.errors?.['invalidCharacters']">
                  Invalid characters are not allowed.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('evaluationTitle')?.touched && assessmentForm.get('evaluationTitle')?.errors?.['firstCharacter']">
                  Assessment name cannot start with a special character.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('evaluationTitle')?.touched && assessmentForm.get('evaluationTitle')?.errors?.['duplicate']">
                  Assessment name already exists.
                </small>

                <small
                  class="text-danger smaller-text"
                  *ngIf="assessmentForm.get('evaluationTitle')?.touched && assessmentForm.get('evaluationTitle')?.errors?.['html']">
                  Invalid input detected.
                </small>
        </div>
      </div>

      <div class="form-group full-width">
        <label> Description </label>

        <textarea
          rows="4"
          placeholder="Short description of the assessment"
          formControlName="evaluationDescription"
        ></textarea>
         <small
            class="smaller-text text-danger"
            *ngIf="assessmentForm.get('evaluationDescription')?.touched && assessmentForm.get('evaluationDescription')?.errors?.['maxLength']">
            Description cannot exceed 500 characters.
          </small>

          <small
            class="smaller-text text-danger"
            *ngIf="assessmentForm.get('evaluationDescription')?.touched && assessmentForm.get('evaluationDescription')?.errors?.['trimSpaces']">
            Extra spaces will be removed.
          </small>

          <small
            class="smaller-text text-danger"
            *ngIf="assessmentForm.get('evaluationDescription')?.touched && assessmentForm.get('evaluationDescription')?.errors?.['whitespace']">
            Please enter a valid description.
          </small>

          <small
            class="smaller-text text-danger"
            *ngIf="assessmentForm.get('evaluationDescription')?.touched && assessmentForm.get('evaluationDescription')?.errors?.['invalidCharacters']">
            Invalid characters entered.
          </small>

          <small
            class="smaller-text text-danger"
            *ngIf="assessmentForm.get('evaluationDescription')?.touched && assessmentForm.get('evaluationDescription')?.errors?.['html']">
            Invalid input detected.
          </small>
      </div>
    </div>
  

    <div class="section">
      <h5 class="section-title">RULESET</h5>

      <div class="form-group full-width">
        <label> Select Ruleset<span>*</span></label>

        <!-- <div class="custom-select">
          <select formControlName="ruleSetId">
            <option value="" selected disabled>Choose a ruleset...</option>
            <option *ngFor="let rule of ruleData"
            [value]="rule.id"
            >{{ rule.name }}</option>
          </select>

          <i class="bi bi-chevron-down"></i>
        </div> -->

        <div class="ruleset-dropdown">

  <div class="ruleset-input" (click)="dropdownOpen = !dropdownOpen">
    <span [matTooltip]="selectedRuleName || ''" matTooltipPosition="above">
      {{ (selectedRuleName || 'Choose a ruleset...').length > 50 ? ((selectedRuleName || 'Choose a ruleset...') | slice:0:50) + '...' : (selectedRuleName || 'Choose a ruleset...') }}
    </span>

    <i class="bi bi-chevron-down"></i>
  </div>

  <div class="ruleset-menu" *ngIf="dropdownOpen">

    <div class="ruleset-list">
      <div
        class="ruleset-item"
        *ngFor="let rule of ruleData"
        (click)="selectRule(rule)"
      >
      <span [matTooltip]="rule.name">
        {{ (rule.name || '-').length > 30 ? ((rule.name || '-') | slice:0:30) + '...' : rule.name || '-' }}
        </span>
      </div>
    </div>

    <div class="ruleset-pagination">

      <button
        type="button"
        (click)="previousPage()"
        [disabled]="currentPage === 1">
        <i class="bi bi-chevron-left"></i>
      </button>

      <span>{{ currentPage }} / {{ totalPages }}</span>

      <button
        type="button"
        (click)="nextPage()"
        [disabled]="currentPage === totalPages">
        <i class="bi bi-chevron-right"></i>
      </button>

    </div>

  </div>

</div>
          <small
            class="text-danger smaller-text"
            *ngIf="assessmentForm.get('ruleSetId')?.touched && assessmentForm.get('ruleSetId')?.hasError('required')">
            Please select a ruleset.
          </small>

        <small> Rule configuration is managed on the ruleset itself. </small>
      </div>
    </div>
    </form>

    <!-- Footer -->

    <div class="modal-footer">
      <button type="button" class="cancel-btn" (click)="closeDialog()">
        Cancel
      </button>

      <ng-container *ngIf="isEdit">
      <button type="button" class="save-btn" (click)="saveAssessment()" [disabled]="assessmentForm.invalid"
       *hasPermission="PermissionForStudents.PROCTORING_UPDATE">
          Update Assessment
        </button>
      </ng-container>

      <ng-container *ngIf="!isEdit">
        <button type="button" class="save-btn" (click)="saveAssessment()" [disabled]="assessmentForm.invalid" 
        *hasPermission="PermissionForStudents.PROCTORING_CREATE">
          Create Assessment
      </button>
      </ng-container>
    </div>
</div>
